// Author thq
// Date 2020-12-15 14:42:39

class EmAclLocationType {
constructor({
        id = null,
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new EmAclLocationType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.admin.emAclLocationType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAclLocationType.grid.remark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    remarkFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAclLocationType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remarkFilter',
        label: 'label.em.admin.emAclLocationType.filter.remark',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.admin.emAclLocationType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAclLocationType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmAclLocationType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
